<template>
    <div class="posts-wrapper">
      <div class="packages memberships">
             
        <!-- <div class="filters">
          <div class="title">Búsqueda</div>
          <div class="wrap-filter">
              <div class="item">
                <label for="">Fechas</label>
                <v-date-picker mode="range" v-model="dateFilter" locale="es" :popover="{ placement: 'top', visibility: 'click' }"></v-date-picker>
              </div>
              <div class="item btnFilter">
                  <vs-button id="btnFilter" class="vs-con-loading__container"  color="primary" type="border" icon="search" @click="searchPackages()">Filtrar</vs-button>
              </div>
          </div>
        </div> -->
        
        <div class="box-white-wrapper" v-if="memberships.length > 0">
          <vs-table :data="memberships" pagination max-items="50" :key="keyPackages" search>
              <template slot="thead">
                  <vs-th sort-key="firstName">Nombre</vs-th>
                  <vs-th sort-key="email">Email</vs-th>
                  <vs-th sort-key="phone">Teléfono</vs-th>
                  <vs-th sort-key="membersQty" class="center">Afiliados</vs-th>
                  <vs-th sort-key="id" class="width-30"></vs-th>
              </template>
              <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].firstName">{{ `${data[indextr].firstName } ${data[indextr].lastName}`}}</vs-td>
                    <vs-td :data="data[indextr].email"> {{ data[indextr].email }}</vs-td>
                    <vs-td :data="data[indextr].phone"> {{ data[indextr].phone }}</vs-td>
                    <vs-td :data="data[indextr].membersQty" class="center"> {{ data[indextr].membersQty }}</vs-td>
                    <vs-td :data="data[indextr].id">
                        <div class="table-actions" v-if="userInfoData.role != Roles.Distribuitor">
                              <router-link :to="`/admin/membership/detail/${data[indextr].id}`"><feather type="eye"/></router-link>
                        </div>
                    </vs-td>                    
                  </vs-tr>
              </template>
          </vs-table>
        </div>
      </div>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import MembershipService from "@/services/MembershipService"
export default {
    name: 'MembershipsView',
    mixins: [helper],
    data () {
        return {
            textarea: "",
            keyPackages: 0,
            noLimit: false,
            typeChangeSt: false,
            Roles: [],
            boxActive: null,
            keyword: "",
            dateFilter: "",
            filterObj: {
                dateFilter: null,
                status: null,
                filter: ""
            },
            memberships: [],
        }
    },
    created(){
        this.Roles = Role
        this.$Progress.start();
        if(this.userInfoData.role != this.Roles.Admin){
            this.$router.push('/')
        }
        this.getFranchisesAd()
        this.$Progress.finish()
    },
    computed: {
        ...mapState([
        'userInfoData'
        ]),
    },
    methods: {
    
        async getFranchisesAd () {
            let response = await MembershipService.getFranchisesAd()
            console.log(response)
            if((response.status / 100) == 2) {
                this.memberships = response.data.data
            }
        },
    }
}
</script>
